// @import
import { ensureHTMLElement } from "@src/js/lib/ensure.js";
import Alpine from "alpinejs";

Alpine.directive("banner-countdown", (element, {}, {cleanup}) => {

  let timer: NodeJS.Timeout

  const raw = {
    // Le Twig rend `.c-banner-count-down__countdown` (et `id="wrapper"`), pas `.countdown`
    wrapper: element.querySelector(".c-banner-count-down__countdown") ?? element.querySelector("#wrapper") ?? element.querySelector(".countdown"),
    days: element.querySelector(".countdown__number--days"),
    hours: element.querySelector(".countdown__number--hours"),
    minutes: element.querySelector(".countdown__number--minutes"),
    seconds: element.querySelector(".countdown__number--seconds"),
  };

  const dom = {
    wrapper : ensureHTMLElement(raw.wrapper),
    days : ensureHTMLElement(raw.days),
    hours : ensureHTMLElement(raw.hours),
    minutes : ensureHTMLElement(raw.minutes),
    seconds : ensureHTMLElement(raw.seconds),
  }

  const rawTimestamp = (dom.wrapper.dataset.timestamp ?? "");
  const parsedTimestamp = Number(rawTimestamp);

  let timeDiff = Math.abs(Date.now() - parsedTimestamp)

  function updateCountdown() {
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (timeDiff % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

        const padZero = (num: number): string => num.toString().padStart(2, '0');

        dom.days.innerHTML = padZero(days);
        dom.hours.innerHTML = padZero(hours);
        dom.minutes.innerHTML = padZero(minutes);
        dom.seconds.innerHTML = padZero(seconds);

        timeDiff = timeDiff - 1000;

        timer = setTimeout(updateCountdown, 1000);
  }

  updateCountdown()

  cleanup(() => {
    timer && clearTimeout(timer)
  })
});
